import { useCommon } from '@/hooks/use-common'
import { useDownloadConfig } from '@/hooks/use-download-config.ts'
import { APP_CONFIG } from '@/project-config'
import { useI18n } from 'i18n-utils'
import { PLATFORM_CONFIG, PlatformKey } from 'platform-config'
import { useEnvStore, useLanguageStore } from 'store'
import { CloseSimpleIcon } from 'ui-components'
import { toCamelCase } from 'utils'
import './FooterAppDownload.scss'

export const FooterAppDownload = defineComponent({
  setup() {
    const showAppDownload = ref(true)
    const languageStore = useLanguageStore()
    const envStore = useEnvStore()
    const { t } = useI18n()
    const footerText = computed(() => {
      const language = languageStore.currentLanguage
      const key = toCamelCase(`app_slogan_${language}`)
      if (!envStore.config) return ''
      if (!envStore.config.language) return ''

      return envStore.config.language[key as keyof typeof envStore.config.language]
    })
    const { isTabbarPage } = useCommon()
    const { onDownloadApp, inviteCode } = useDownloadConfig()
    return () => {
      if (isTabbarPage.value) return null
      if (inviteCode.value && ['88'].includes(PlatformKey)) return null
      if (!APP_CONFIG.isShowFooterAppDownload) return null
      if (showAppDownload.value) {
        return (
          <div class="footer-app-download-layout">
            <div class="footer-app-download">
              <img width={36} alt="" class="simple-logo" src={PLATFORM_CONFIG.simpleLogo} />
              <div class="app-tip">
                <span class="footer-title">{footerText.value}</span>
              </div>
              <div class="text-download" onClick={onDownloadApp}>
                {t('下载')}
              </div>
              <span class="close-icon" onClick={() => (showAppDownload.value = false)}>
                <CloseSimpleIcon />
              </span>
            </div>
          </div>
        )
      }
      return null
    }
  },
})
